/* ============================================================
   CART DRAWER — live edits without the reprint

   theme.liquid's original drawerQty() posted the change and then
   rebuilt the whole list from scratch, so every + / − flashed
   the receipt and replayed the print-in. This replaces those two
   functions (it loads deferred, so it runs after theme.liquid
   defined them; the onclick handlers look the name up at click
   time, so they pick these up):

   - the number and the line total change the instant you tap,
     before the request has even left
   - the server's answer only patches figures in place: quantity,
     line price, subtotal, the three bag counters
   - a line removed slides out on its own; nothing else moves
   - taps that arrive while a request is in flight are coalesced:
     the latest quantity wins, one request at a time per line
   - the list is only rebuilt when lines are added or removed
     from elsewhere (Quick Add, another tab)

   Markup and class names are unchanged, so urbanleb-cart.css
   applies as-is.
   ============================================================ */
(function () {
  'use strict';
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var state = { items: [], inflight: {}, want: {}, unit: {} };

  function $(id) { return document.getElementById(id); }
  function els() {
    return { items: $('drawerItems'), footer: $('drawerFooter'), empty: $('drawerEmpty'),
             sub: $('drawerSubtotal'), counts: document.querySelectorAll('#cartCount,#drawerCount,#bottomNavCount') };
  }

  function rowHTML(item) {
    return '<div class="drawer-item" data-key="' + item.key + '">'
      + '<div class="drawer-item__img"><a href="' + item.url + '"><img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '"></a></div>'
      + '<div class="drawer-item__info">'
      + '<a href="' + item.url + '" class="drawer-item__title">' + item.product_title + '</a>'
      + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="drawer-item__variant">' + item.variant_title + '</div>' : '')
      + '<div class="drawer-item__price" data-line>' + money(item.line_price) + '</div>'
      + '<div class="drawer-item__qty">'
      + '<button type="button" aria-label="Less" onclick="drawerQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>'
      + '<span data-qty>' + item.quantity + '</span>'
      + '<button type="button" aria-label="More" onclick="drawerQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>'
      + '</div></div>'
      + '<button type="button" class="drawer-item__remove" aria-label="Remove" onclick="drawerQty(\'' + item.key + '\',0)">✕</button>'
      + '</div>';
  }

  /* re-point the + / − buttons at the new neighbouring quantities */
  function rewire(row, key, qty) {
    var b = row.querySelectorAll('.drawer-item__qty button');
    if (b[0]) b[0].setAttribute('onclick', "drawerQty('" + key + "'," + (qty - 1) + ')');
    if (b[1]) b[1].setAttribute('onclick', "drawerQty('" + key + "'," + (qty + 1) + ')');
  }

  function paintTotals(cart) {
    var e = els();
    e.counts.forEach(function (n) { n.textContent = cart.item_count; });
    if (e.sub) e.sub.textContent = money(cart.total_price);
    if (cart.item_count === 0) {
      if (e.footer) e.footer.style.display = 'none';
      if (e.empty) e.empty.style.display = 'flex';
    } else {
      if (e.empty) e.empty.style.display = 'none';
      if (e.footer) e.footer.style.display = 'block';
    }
  }

  /* full render: only when the set of lines changed */
  function render(cart) {
    var e = els(); if (!e.items) return;
    state.items = cart.items.slice();
    cart.items.forEach(function (it) { state.unit[it.key] = it.price; });
    e.items.innerHTML = cart.items.map(rowHTML).join('');
    paintTotals(cart);
  }

  /* patch: figures only, no rebuild */
  function patch(cart) {
    var e = els(); if (!e.items) return;
    var seen = {};
    cart.items.forEach(function (it) {
      seen[it.key] = true; state.unit[it.key] = it.price;
      var row = e.items.querySelector('.drawer-item[data-key="' + it.key + '"]');
      if (!row) return;
      var q = row.querySelector('[data-qty]'), p = row.querySelector('[data-line]');
      /* don't overwrite a quantity the user has already moved past */
      if (state.want[it.key] === undefined || state.want[it.key] === it.quantity) {
        if (q) q.textContent = it.quantity;
        if (p) p.textContent = money(it.line_price);
        rewire(row, it.key, it.quantity);
      }
    });
    [].slice.call(e.items.querySelectorAll('.drawer-item')).forEach(function (row) {
      var k = row.getAttribute('data-key');
      if (!seen[k] && !row.classList.contains('is-going')) leave(row);
    });
    state.items = cart.items.slice();
    paintTotals(cart);
  }

  function sameLines(cart) {
    var e = els(); if (!e.items) return false;
    var rows = e.items.querySelectorAll('.drawer-item:not(.is-going)');
    if (rows.length !== cart.items.length) return false;
    for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-key') !== cart.items[i].key) return false;
    return true;
  }

  function leave(row) {
    row.classList.add('is-going');
    row.style.height = row.offsetHeight + 'px';
    requestAnimationFrame(function () { row.classList.add('is-gone'); });
    setTimeout(function () { if (row.parentNode) row.parentNode.removeChild(row); }, 420);
  }

  window.loadCartDrawer = function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var e = els(); if (!e.items) return;
      if (cart.item_count === 0) { e.items.innerHTML = ''; state.items = []; paintTotals(cart); return; }
      if (sameLines(cart)) patch(cart); else render(cart);
    });
  };

  function send(key) {
    var qty = state.want[key];
    state.inflight[key] = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.inflight[key] = false;
        if (state.want[key] !== qty) { send(key); return; }   /* a newer tap is waiting */
        delete state.want[key];
        if (cart && cart.items) patch(cart);
      })
      .catch(function () { state.inflight[key] = false; delete state.want[key]; window.loadCartDrawer(); });
  }

  window.drawerQty = function (key, qty) {
    qty = Math.max(0, qty | 0);
    var e = els(); if (!e.items) return;
    var row = e.items.querySelector('.drawer-item[data-key="' + key + '"]');
    state.want[key] = qty;
    if (row) {
      if (qty === 0) { leave(row); }
      else {
        var q = row.querySelector('[data-qty]'), p = row.querySelector('[data-line]');
        if (q) q.textContent = qty;
        if (p && state.unit[key] != null) p.textContent = money(state.unit[key] * qty);
        rewire(row, key, qty);
      }
      /* optimistic subtotal + counters so the figures move with the tap */
      var sum = 0, n = 0;
      [].slice.call(e.items.querySelectorAll('.drawer-item:not(.is-going)')).forEach(function (r) {
        var k = r.getAttribute('data-key'), qq = parseInt(r.querySelector('[data-qty]').textContent, 10) || 0;
        if (state.unit[k] != null) sum += state.unit[k] * qq; n += qq;
      });
      if (e.sub) e.sub.textContent = money(sum);
      e.counts.forEach(function (c) { c.textContent = n; });
      if (n === 0) { if (e.footer) e.footer.style.display = 'none'; if (e.empty) e.empty.style.display = 'flex'; }
    }
    if (!state.inflight[key]) send(key);
  };
  /* ---------- adding: a slip, not the whole bag ----------
     The original quickAdd()/qvAddToCart() opened the drawer after
     every add, which gets in the way of someone adding several
     pieces. Now an add pulses the bag counters and prints a small
     slip at the bottom with the item's name and a "View bag"
     button; the drawer only refreshes if it is already open.  */
  function slip(item) {
    var t = $('ulToast');
    if (!t) {
      t = document.createElement('div'); t.id = 'ulToast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<span class="ulToast__n">Added</span><span class="ulToast__t"></span><button type="button" onclick="openCartDrawer()">View bag</button>';
      document.body.appendChild(t);
    }
    t.querySelector('.ulToast__t').textContent = (item && item.product_title) || '';
    t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 3400);
  }
  function afterAdd(item) {
    if (window.refreshCartCount) refreshCartCount();
    if (window.pulseBagButtons) pulseBagButtons();
    var d = $('cartDrawer');
    if (d && d.classList.contains('open')) window.loadCartDrawer();
    slip(item);
  }
  window.quickAdd = function (id, btn) {
    if (btn && btn.disabled) return;
    if (btn) { btn.disabled = true; btn.classList.add('adding'); btn.textContent = '...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (btn) { btn.classList.remove('adding'); btn.classList.add('added'); btn.textContent = '✓ Added'; }
        afterAdd(item);
        if (btn) setTimeout(function () { btn.classList.remove('added'); btn.textContent = 'Add'; btn.disabled = false; }, 1600);
      })
      .catch(function () { if (btn) { btn.classList.remove('adding'); btn.textContent = 'Add'; btn.disabled = false; } });
  };
  window.qvAddToCart = function () {
    var vid = window.qvVariantId; if (!vid) return;
    var btn = $('qvAtc'); if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (btn) btn.textContent = '✓ Added';
        afterAdd(item);
        setTimeout(function () { if (window.closeQuickView) closeQuickView(); if (btn) { btn.textContent = 'Add to Bag →'; btn.disabled = false; } }, 700);
      })
      .catch(function () { if (btn) { btn.textContent = 'Add to Bag →'; btn.disabled = false; } });
  };
})();
